import { render, staticRenderFns } from "./TabNotice.vue?vue&type=template&id=4a81fc01&"
import script from "./TabNotice.vue?vue&type=script&lang=js&"
export * from "./TabNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports